module.exports = __webpack_public_path__ + "img/desktop.77450b12.png";